import React, { ReactElement, useMemo } from 'react';
import { BaseTreeItem } from '../../../common/type/import';
import { ExamImportRequest, ExamPartImportRequest, ExamPartQuestionImportRequest } from '../../../model/request';

interface Props {
  dataTree: BaseTreeItem | null;
  renderTreeItem: (title: string, currentTreeItem: BaseTreeItem) => ReactElement;
  selectEditItem: (
    selectEditItem: ExamImportRequest | ExamPartImportRequest | ExamPartQuestionImportRequest | null,
  ) => void;
}

export default function ExamMenuItem({ dataTree, renderTreeItem, selectEditItem }: Props) {
  const title = useMemo(() => {
    return dataTree?.title;
  }, [dataTree]);

  if (!dataTree) return null;

  return (
    <li className="w-full">
      <li className={'list-none block w-full'} onClick={() => selectEditItem(dataTree?.item)}>
        {renderTreeItem(title ? title : '', dataTree)}
      </li>
      {dataTree.children.length > 0 ? (
        <ul className={'ml-3'}>
          {dataTree.children.map((item, index) => {
            return (
              <li className="mt-2 block w-full" key={index}>
                <ExamMenuItem dataTree={item} renderTreeItem={renderTreeItem} selectEditItem={selectEditItem} />
              </li>
            );
          })}
        </ul>
      ) : null}
    </li>
  );
}
